// extracted by mini-css-extract-plugin
export default {"landscapeCommoditiesWrapper":"LandscapeCommoditiesPage_landscapeCommoditiesWrapper__9LeVb"};